// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"4b655ea8","787":"e2d24938","794":"e749c0c8"}[chunkId] + ".chunk.js";
};